module.exports = __webpack_public_path__ + "img/header-green-bottom-square.b56d5c65.svg";